const IconTicketItem = ({ className }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M8.35431 6.66831V6.77557H6.57124C6.54896 6.36158 6.27489 6.01451 5.89945 5.88477C6.29128 5.74937 6.5727 5.37723 6.5727 4.93937V3.99397C6.5727 3.55611 6.29128 3.18397 5.89945 3.04857C6.27489 2.91883 6.54896 2.57176 6.57124 2.15777H8.35431V2.26503C8.09256 2.38391 7.85164 2.54962 7.64445 2.75681C7.19097 3.2103 6.93621 3.82535 6.93621 4.46667C6.93621 5.10799 7.19097 5.72304 7.64445 6.17652C7.85164 6.38372 8.09256 6.54943 8.35431 6.66831ZM1.8457 2.26503V2.15777H4.57417C4.59645 2.57176 4.87052 2.91883 5.24596 3.04857C4.85413 3.18397 4.5727 3.55611 4.5727 3.99397V4.93937C4.5727 5.37723 4.85413 5.74937 5.24596 5.88477C4.87052 6.01451 4.59645 6.36158 4.57417 6.77557H1.8457V6.66831C2.10745 6.54943 2.34837 6.38372 2.55556 6.17653C3.00904 5.72304 3.2638 5.10799 3.2638 4.46667C3.2638 3.82535 3.00904 3.2103 2.55556 2.75681C2.34837 2.54962 2.10745 2.38391 1.8457 2.26503Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconTicketItem;
